import type { WebRegionResolveResponse } from '@cibli/shared';

import api from './api';

export async function resolveWebRegion(countryCode?: string): Promise<WebRegionResolveResponse> {
  const query = countryCode ? `?country=${encodeURIComponent(countryCode)}` : '';
  return api.get<WebRegionResolveResponse>(`/web-regions/resolve${query}`);
}

